// extracted by mini-css-extract-plugin
export default {"navbar":"Menu_navbar__sW2x7","navbar__list":"Menu_navbar__list__lSew8","navbar__item":"Menu_navbar__item__e+YkD"};